import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { AppLayout } from './layout/components/app.layout';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: '',
    component: AppLayout,
    canActivate: [authGuard],
    children: [
      {
        path: 'notifications',
        loadChildren: () =>
          import('./pages/notifications/notifications.routes').then((m) => m.notificationsRoutes),
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./pages/notifications/admin/admin.routes').then((m) => m.adminRoutes),
      },
      { path: '', redirectTo: 'notifications', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: 'notifications' },
];
